<template>
  <div class="wrap-bg wrap-data-manage wrap-content-batchUpload pd15">
    <v-breadcrumb v-if="isShowBread" :breadcrumb-list="breadcrumbList" />
    <div class="breadcrumb-btm-con-box">
      <h3 class="f-fs16 f-fwn bor-btm-gray pd15 bg-white f-df f-ai breadcrumb-btm-con-box">
        <span>千瓜数据导入</span>
      </h3>
      <div class="file-upload-box bg-white pd-left15">
        <!-- 上传 -->
        <file-upload :down-load-obj="downLoadObj" up-load-url="/api/data/qg/file" />
        <div class="mg-top30 f-lh24 pd-btm30">
          <h5>操作说明：</h5>
          <div class="mg-left20">
            <p>您可在此导入千瓜导出的数据，操作步骤如下：</p>
            <p>1、点击<span class="f-fwb">下载模板</span>，获取数据模板；</p>
            <p>2、按模板的格式整理数据，模板的表头及填写要求如下：</p>
            <div class="pd-row15">
              <p>（1）<span class="f-fwb">达人昵称</span>：选填，可留空</p>
              <p>（2）<span class="f-fwb">达人主页</span>：选填，可留空</p>
              <p>（3）<span class="f-fwb">达人红薯等级</span>：选填，可留空</p>
              <p>（4）<span class="f-fwb">地域</span>：选填，可留空</p>
              <p>（5）<span class="f-fwb">达人类型</span>：选填，可留空</p>
              <p>（6）<span class="f-fwb">达人粉丝数</span>：选填，可留空，不填则默认为0，填写整数</p>
              <p>（7）<span class="f-fwb">笔记发布时间</span>：选填，可留空</p>
              <p>（8）<span class="f-fwb">内容类型</span>：选填，可留空</p>
              <p>（9）<span class="f-fwb">点赞</span>：尽量填，可留空，不填则默认为0，填写整数</p>
              <p>（10）<span class="f-fwb">评论</span>：尽量填，可留空，不填则默认为0，填写整数</p>
              <p>（11）<span class="f-fwb">收藏</span>：尽量填，可留空，不填则默认为0，填写整数</p>
              <p>（12）<span class="f-fwb">分享</span>：尽量填，可留空，不填则默认为0，填写整数</p>
              <p>（13）<span class="f-fwb">笔记形式</span>：选填，可留空</p>
              <p>（14）<span class="f-fwb">报备合作品牌</span>：如有则尽量填，可留空，不填则默认空</p>
              <p>（15）<span class="f-fwb">笔记类型</span>：选填，可留空</p>
              <p>（16）<span class="f-fwb">笔记链接</span>：必填</p>
              <p>（17）<span class="f-fwb">是否品牌合作人</span>：尽量填，可留空，不填则默认未知</p>
              <p>（18）<span class="f-fwb">是否商业笔记</span>：尽量填，可留空，不填则默认未知</p>
              <p>（19）<span class="f-fwb">笔记涵盖热搜词Top10</span>：选填，可留空</p>
              <p>（20）<span class="f-fwb">笔记相关评论热词Top10</span>：选填，可留空</p>
            </div>
            <p>3、点击<span class="f-fwb">选择文件</span>，选择整理好的数据文件；</p>
            <p>4、点击<span class="f-fwb">上传文件</span>，完成。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vBreadcrumb from '@/components/breadcrumb.vue'
import FileUpload from '@/components/fileUpload.vue'
export default {
  components: {
    vBreadcrumb,
    FileUpload
  },
  data() {
    return {
      isShowBread: false,
      breadcrumbList: [
        {
          name: '数据管理'
        },
        {
          name: '笔记数据ZQ管理',
          path: '/dataManage/list'
        },
        {
          name: '批量导入'
        }
      ],
      fileLoadUrl: '',
      downLoadObj: {
        url: '/api/data/file/path',
        param: {
          type: 4
        },
        fileName: '千瓜数据模板.xlsx'
      }
    }
  },
  methods: {
    backBtn() {
      this.$router.push({
        path: '/dataManage/list'
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/color.less';
.file-upload-box{
  min-height: calc(~'100vh - 200px');
}
</style>
